import React from 'react'
import remote from './../assets/remote.png'

const Revenue = () => {
  return (
    <div className='w-4/5 m-auto'>
      <div className='flex justify-around revenue-container'>
        <div className='revenue-text'>
            <span className='bg-[#e5f5ef] py-3 px-5 text-[#52BD95]'>Boost Your Work</span>
            <h1 className='font-bold text-4xl leading-10 mt-5 pt-3'>Boost Your Revenue</h1>
            <p className='mb-10 mt-5 '>From they fine john he give of rich he.They age and draw<br/>mrs like.Improving end distrusts may instantly was <br />household applauded incommode.Why kept very ever<br />home mrs.Considered symphathize ten uncommonly <br />occasional assistance sufficiant not.Letter of on become <br />he tended active enable too.Vicinity relation sensible<br />sociable surprise screened no up as.</p>
            <span className='bg-[#52BD95] py-3 px-5 text-[#fff]'>Explore Features</span>
        </div>
        <div>
            <div className=''>
                <img src={remote} alt='remote' />
            </div>
        </div>
      </div>
    </div>
  )
}

export default Revenue